import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import parse from "html-react-parser";

const EmbedFormTemplateFaileds = ({
  allowUseForm,
  loading,
  isPreview,
  allowUseFormText,
  activeForm,
  notExistForm,
}) => {
  const { getTextByKey } = useContent();

  const renderFormText = () => {
    let text = getTextByKey("form-not-active");
    if (notExistForm) {
      text = getTextByKey("not-exist-form");
    } else if (!activeForm) {
      text = getTextByKey("form-not-active");
    } else if (!allowUseForm) {
      text = parse(getTextByKey(allowUseFormText));
    }
    return text;
  };

  return (
    <>
      {!loading && !isPreview && (
        <div className="unactive-form-container">
          <div className="unactive-content">
            <div className="unactive-image">
              <Image name="personal/off" ext="svg" alt="" title="" />
            </div>
            <div className="unactive-text">
              <span>{renderFormText()}</span>
            </div>
          </div>
          <div className="unactive-form-button">
            <span>{getTextByKey("form-continue")}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default EmbedFormTemplateFaileds;
